import { isArray, isEmpty, isPlainObject, isString } from 'lodash-es';

import type { AnyObject } from '../../../types/common';

export function nestedObjectToDotNotation(
  obj: AnyObject,
  p?: string,
  r?: AnyObject,
): AnyObject {
  const prefix = p || '';
  const result = r || {};

  if (isArray(obj)) {
    let isStrings = true;
    obj.forEach((value: AnyObject) => {
      if (!isString(value)) {
        isStrings = false;
      }
    });
    if (isStrings) {
      result[prefix] = obj;
      return result;
    }
  }

  if (isString(obj)) {
    result[prefix] = obj;
    return result;
  }

  if (isArray(obj) || isPlainObject(obj)) {
    for (const i in obj) {
      if (obj) {
        let pref = prefix;
        if (isArray(obj)) {
          pref = `${pref}`;
        } else if (isEmpty(prefix)) {
          pref = i;
        } else {
          pref = `${prefix}.${i}`;
        }
        nestedObjectToDotNotation(obj[i], pref, result);
      }
    }
    return result;
  }
  return result;
}
